<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area vision">
      <div class="tit_area">
        <div class="sub_tit">VISION</div>
        <div class="sub_txt">
          Smart Innovative Eco-Friendly Construction<br />스마트하고 혁신적이며,
          친환경적인 건설 시장을 열어갑니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <h3 class="h3_tit">기업철학</h3>
      <div class="tit_sub">
        한국오션플랫폼은 장기적이고 전략적인 안목으로 안정적인 건축 사업구조를
        구축했고, 창립 이래 끊임없는 도전과 연구를 통해 새로운 미래를
        창조함으로써 인류사회의 꿈을 실현합니다.
      </div>
      <div class="aCenter mgt80 mgb100 gs_y">
        <img
          :src="`${resources}img/img_vision1-2.png`"
          alt="스마트한 첨단기술:Smart(21세기형 최첨단 자동생산라 구축으로 미래가치 실현 추구), 지속적 혁신 innovative(건설공사의 생산성, 안정성, 품질 등을 향상시키는 공법 추구), 미래형 건축 Construction( 건축을 뛰어 넘는 효율적 공간 창조로 미래형 신개념 건축 추구), 친환경 경영 Eco-Friendly(건설공사에서 발생하는 비산먼지.부산물 등을 최소화해 친환경 공사 추구) "
        /><!--// 2021-08-11 수정 -->
      </div>
    </div>
    <div class="sub_contents bg_gray">
      <div class="inner">
        <h3 class="h3_tit">핵심가치</h3>
        <div class="tit_sub">
          한국오션플랫폼은 4대 핵심가치를 통해 선진 건축 문화를 구축하며 성공
          DNA를 더욱 발전시켜 나갈 것입니다.
        </div>
        <ul class="vision_cont gs_st">
          <li>
            <dl>
              <dt>
                <strong>가치창출</strong>
                <em>Value Creation</em>
              </dt>
              <dd>
                현재에 안주하지 않고 <br />새로운 가치를 창출하여<br />더 큰
                미래로 나아간다.
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>
                <strong>고객지향</strong>
                <em>Customer Satisfaction</em>
              </dt>
              <dd>
                고객 입장 에서 생각하며<br />최고의 품질과 서비스로<br />고객만족을
                실현한다.
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>
                <strong>협력</strong>
                <em>Speak Together</em>
              </dt>
              <dd>
                동료, 파트너사와<br />열린 마음으로 소통하고<br />함께 발전한다.
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt>
                <strong>원칙과 기본준수</strong>
                <em>Rule & Responsibility</em>
              </dt>
              <dd>원칙과 기본을 지키며 <br />책임은 반드시<br />완수한다.</dd>
            </dl>
          </li>
        </ul>
      </div>
      <!--// 2021-08-11 수정 -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page],
  mounted() {
    this.initTween();
  }
};
</script>

<style lang="scss" scoped></style>
